import { render, staticRenderFns } from "./seniority-remuneration-table-header.component.vue?vue&type=template&id=f1e39482&scoped=true&"
import script from "./seniority-remuneration-table-header.component.vue?vue&type=script&lang=ts&"
export * from "./seniority-remuneration-table-header.component.vue?vue&type=script&lang=ts&"
import style0 from "./seniority-remuneration-table-header.component.vue?vue&type=style&index=0&id=f1e39482&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1e39482",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCheckbox,VCol,VIcon,VRow})
